import { createFileRoute } from "@tanstack/react-router";

import UsdaCalibration from "~/pages/UsdaCalibration";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-image-calibration")({
  staticData: ROUTE_STATIC.usdaImageCalibration,
  component: UsdaCalibration,
});
